module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"series":"Series","comments":"Comments","metadata":"Metadata"},"fr":{"series":"Séries","comments":"Commentaires","metadata":"Métadonnées"}}')
  delete Component.options._Ctor
}
